(function () {
  function initSanameAccordions(root) {
    (root || document).querySelectorAll('[data-saname-accordions]').forEach(function (group) {
      if (group.dataset.sanameReady === 'true') return;
      group.dataset.sanameReady = 'true';
      group.querySelectorAll('.SanamePdpAccordion__Button').forEach(function (button) {
        button.addEventListener('click', function () {
          var item = button.closest('.SanamePdpAccordion');
          var open = item.classList.toggle('is-open');
          button.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initSanameAccordions(document); });
  document.addEventListener('shopify:section:load', function (event) { initSanameAccordions(event.target); });
})();
